// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { i18n } from '@lingui/core';
import moment from 'moment';
import { BookitupNotification } from '../../../../Types/LogT';
import { RoutingS } from '../../../../Service/RoutingS';
import LinkText from '../../../../Atoms/LinkText';

const RecommendationAvailabilityChanged: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { personDescription, eventId, value, eventDate } = notification;

  return (
    <Text>
      <Text span weight="bolder">
        {` ${personDescription} `}
      </Text>
      hat den Verfügbarkeitsstatus für das Event am
      <LinkText span weight="bolder" onClick={() => RoutingS.openInNewTab(`/events/${eventId}/details`)}>
        {eventDate && ` ${moment(eventDate).format('LL')}`}
      </LinkText>
      <Text span weight="bolder">
        {` auf ${i18n._(`recommendation.answer.${value}`)} `}
      </Text>
      gesetzt.
    </Text>
  );
};

export default RecommendationAvailabilityChanged;
